/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface APIKeyMetadata
 */
export interface APIKeyMetadata {
    /**
     *
     * @type {string}
     * @memberof APIKeyMetadata
     */
    readonly id: string;
    /**
     *
     * @type {string}
     * @memberof APIKeyMetadata
     */
    readonly prefix: string;
    /**
     *
     * @type {Date}
     * @memberof APIKeyMetadata
     */
    readonly created: Date;
    /**
     *
     * @type {string}
     * @memberof APIKeyMetadata
     */
    readonly name: string;
}

/**
 * Check if a given object implements the APIKeyMetadata interface.
 */
export function instanceOfAPIKeyMetadata(value: object): value is APIKeyMetadata {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('prefix' in value) || value['prefix'] === undefined) return false;
    if (!('created' in value) || value['created'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function APIKeyMetadataFromJSON(json: any): APIKeyMetadata {
    return APIKeyMetadataFromJSONTyped(json, false);
}

export function APIKeyMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIKeyMetadata {
    if (json == null) {
        return json;
    }
    return {

        'id': json['id'],
        'prefix': json['prefix'],
        'created': (new Date(json['created'])),
        'name': json['name'],
    };
}

  export function APIKeyMetadataToJSON(json: any): APIKeyMetadata {
      return APIKeyMetadataToJSONTyped(json, false);
  }

  export function APIKeyMetadataToJSONTyped(value?: Omit<APIKeyMetadata, 'id'|'prefix'|'created'|'name'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

    };
}
